import { render } from "./FinisciRilevazione.vue?vue&type=template&id=fe35fd30&scoped=true"
import script from "./FinisciRilevazione.vue?vue&type=script&lang=js"
export * from "./FinisciRilevazione.vue?vue&type=script&lang=js"

import "./FinisciRilevazione.vue?vue&type=style&index=0&id=fe35fd30&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe35fd30"]])

export default __exports__